import Vue from 'vue'
import App from './App.vue'
import router from './router'
import moment from 'moment'//导入文件 

Vue.prototype.$moment = moment;//赋值使用
import './plugins/element.js'
// 导入字体图标
import './assets/fonts/iconfont.css'
// 导入全局样式表
import './assets/css/global.css'
import TreeTable from 'vue-table-with-tree-grid'

// 粒子插件
import VueParticles from 'vue-particles'
Vue.use(VueParticles)

// 导入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
// require styles 导入富文本编辑器对应的样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 导入 NProgress 包对应的JS和CSS
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import axios from 'axios'       // 开发环境，也就是本地的
// 配置请求的跟路径
//axios.defaults.baseURL = 'http://192.168.1.16:41278/'
axios.defaults.baseURL = 'https://miniapp.psychology.haidjk.com/'

// 在 request 拦截器中，展示进度条 NProgress.start()
axios.interceptors.request.use(config => {
  // 启动进度条
  NProgress.start();

  // 从 sessionStorage 中获取 token
  const token = window.sessionStorage.getItem('token');

  // 如果 token 存在，将其添加到请求头
  if (token) {
      config.headers.Authorization = `Bearer ${token}`; // 使用 Bearer 作为前缀
  }

  // 在最后必须 return config
  return config;
}, error => {
  // 请求出错时停止进度条
  NProgress.done();
  return Promise.reject(error);
});
// 在 response 拦截器中，隐藏进度条 NProgress.done()
axios.interceptors.response.use(config => {
  NProgress.done()
  return config
})
Vue.prototype.$http = axios

Vue.config.productionTip = false

Vue.component('tree-table', TreeTable)
// 将富文本编辑器，注册为全局可用的组件
Vue.use(VueQuillEditor)

Vue.filter('dateFormat', function(originVal) {
  const dt = new Date(originVal)

  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
